import './styles.sass'

import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
interface ISpinnerProps {
  style?: any
}

const Spinner = ({style}: ISpinnerProps) => {
  return (
    <div className="spinner" style={style}>
      <FontAwesomeIcon className="infinityRotation" icon="spinner" />
    </div>
  );
};

export default Spinner;
  